import * as React from 'react';
import { darkGrey1 } from '../../common/colors';
import { StyledInformationalPage } from '../../common/static.styles';
import { FeaturedBanner } from '../../components/featured-banner/FeaturedBanner';
import { HeadTitle } from '../../components/head-title/HeadTitle';
import { PressMaterial } from '../../components/press-material/PressMaterial';
import { RowHeader } from '../../components/row-header/RowHeader';
import { DefaultLayout } from '../default/DefaultLayout';
import { PressCenterProps } from './PressCenterLayout.props';
import { StyledPressCenterContents } from './PressCenterLayout.styles';

// noinspection JSUnusedGlobalSymbols
export default ({ locale, seo, pageTitle, displayTitle, topBannerProps, pressMaterialData }: PressCenterProps) => (
  <DefaultLayout locale={locale} seo={seo} bgColor={darkGrey1}>
    <HeadTitle title={pageTitle} />
    <StyledInformationalPage>
      <FeaturedBanner headingTag='h1' {...topBannerProps} />
      <section>
        <RowHeader title={displayTitle} />
        <StyledPressCenterContents>
          {pressMaterialData.map((material, i: number) => (
            <PressMaterial {...material} key={material.title} index={i} />
          ))}
        </StyledPressCenterContents>
      </section>
    </StyledInformationalPage>
  </DefaultLayout>
);
